import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui";

const COOKIE_CONSENT_KEY = "stablebrld_cookie_consent";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Verifica se o usuário já aceitou os cookies
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Pequeno delay para melhor UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50"
          role="banner"
          aria-live="polite"
        >
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl pb-4 sm:pb-6">
            <div className="bg-white border border-neutral-200 rounded-xl shadow-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              {/* Ícone de Cookie */}
              <div className="flex-shrink-0">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-neutral-100 flex items-center justify-center">
                  <Cookie className="w-5 h-5 sm:w-6 sm:h-6 text-neutral-700" />
                </div>
              </div>

              {/* Conteúdo */}
              <div className="flex-1 min-w-0">
                <h3 className="text-sm sm:text-base font-semibold text-neutral-900 mb-1 sm:mb-2">
                  Cookies
                </h3>
                <p className="text-xs sm:text-sm text-neutral-600 leading-relaxed mb-2 sm:mb-3">
                  A stableBRLD poderá utilizar cookies com o objetivo de tornar a sua experiência em nossa página oficial mais completa e efetiva. Caso você desative os cookies no próprio navegador, poderá causar eventuais interrupções em nosso serviço.
                </p>
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 text-xs sm:text-sm">
                  <a
                    href="https://www.liqi.com.br/documents/terms-of-use/document.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-neutral-700 hover:text-neutral-900 underline underline-offset-2 transition-colors"
                  >
                    Termos de uso
                  </a>
                </div>
              </div>

              {/* Botão de Aceitar */}
              <div className="flex-shrink-0 w-full sm:w-auto">
                <Button
                  onClick={handleAccept}
                  className="w-full sm:w-auto"
                  size="sm"
                >
                  Ok, entendi
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
